import React from "react";
import { compose, lifecycle } from "recompose";
import { fetchApi } from "core/api/hoc";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import * as insidersApi from "modules/insiders/api";
import * as insidersSelectors from "modules/insiders/selectors";
import { Spinner } from "components/generic/kit";
import View from "./View";

export default compose(
  connect(
    createStructuredSelector({
      objectives: insidersSelectors.getCallObjectivesApi,
      selected: insidersSelectors.getCallObjectiveApi
    }),
    {
      onObjectiveChange: id => insidersApi.getCallObjective.request({ id })
    }
  ),
  fetchApi(insidersApi.getCallObjectives, () => ({
    selector: insidersSelectors.getCallObjectivesApi,
    sync: true,
    Loader
  })),
  fetchApi(insidersApi.getCallObjective, props => ({
    selector: insidersSelectors.getCallObjectiveApi,
    sync: true,
    payload: {
      id: props.objectives.data[0].id
    },
    Loader
  })),
  lifecycle({
    componentDidMount() {
      this.props.onMainObjectiveChange(this.props.selected.data.id);
    }
  })
)(View);

const Loader = () => (
  <div className="flex justify-center">
    <Spinner />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Objective/Provider.js